import { IVipPoint } from 'components/Pages/BoonusPage/components/VipProgress/components/VipProgressDot/types';

export const VIP_POINTS: IVipPoint[] = [
  { wager: 0, isVip: false, withIcon: false, rewards: [] },
  { wager: 25000, isVip: false, withIcon: false, rewards: [] },
  { wager: 50000, isVip: false, withIcon: false, rewards: [] },
  { wager: 75000, isVip: false, withIcon: false, rewards: [] },
];
